import React, { useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { AppContext } from './../App'
import { RadInput2 } from './RadInput2'

export function RadTopNavigation () {
  const { navigationOpen, setNavigationOpen, permissionDenied, notFound, setPermissionDenied, setNotFound } = useContext(AppContext)
  const navigate = useNavigate()
  const location = useLocation()
  const showSearch = location.pathname !== '/' && location.pathname !== '/search'
  const showNav = permissionDenied == null && !notFound

  const handleSearchSubmit = ({ detail }) => {
    const searchText = detail.value.trim()
    if (searchText != null && searchText.length > 0) {
      setNavigationOpen(false)
      navigate(`/search?search=${encodeURIComponent(searchText)}`)
    }
  }

  return (
    <header className='awsui_top-navigation'>
      <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
        {
          showNav &&
            <button
              onClick={() => setNavigationOpen(!navigationOpen)}
              className={'sidebar-toggle ' + (navigationOpen ? 'open' : 'closed')}
            >
              <div className='bar bar1' />
              <div className='bar bar2' />
              <div className='bar bar3' />
            </button>
        }
        <img
          src='/logo.png'
          alt='logo'
          onClick={() => {
            if (permissionDenied != null) {
              setPermissionDenied(null)
            }

            if (notFound) {
              setNotFound(false)
            }

            navigate('/')
          }}
          style={{ cursor: 'pointer' }}
        />
      </div>
      {showSearch && (
        <RadInput2
          onEnter={handleSearchSubmit}
          type='search'
          placeholder='Search...'
          className='global-search-input'
        />
      )}
    </header>
  )
}
